import { render, staticRenderFns } from "./ProductInactive.vue?vue&type=template&id=644266b1&scoped=true&"
import script from "./ProductInactive.vue?vue&type=script&lang=js&"
export * from "./ProductInactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644266b1",
  null
  
)

export default component.exports